import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/Login";
import ChooseLocation from "../views/ChooseLocation";
import Pin from "../views/Pin";
import Numpad from "../components/Numpad";

import LastEntries from "../views/LastEntries";
import Activities from "../views/Activities";
import Rows from "../views/Rows";
import Teams from "../views/Teams";
import Settings from "../views/Settings";

import ChooseActivity from "../views/ChooseActivity";
import ChooseTeam from "../views/ChooseTeam";
import ChooseRow from "../views/ChooseRow";
import RowStatus from "../views/RowStatus";
import RowPercentage from "../views/RowPercentage";
import Packaging from "../views/Packaging";
import Amount from "../views/Amount";
import EditEntry from "../views/EditEntry";
import Workday from "../views/Workday";
import Break from "../views/Break";
import MainMenu from "../views/MainMenu";

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'login', components: { default: Login} },
  { path: '/menu', name: 'menu', components: { default:  MainMenu }, meta: { requiresAuth: true } },
  { path: '/choose-location', name: 'choose-location', components: { default: ChooseLocation} },
  { path: '/pin', name: 'pin', components: { default: Pin, numpad: Numpad }, meta: { requiresAuth: true } },

  { path: '/last-entries', name: 'last-entries', components: { default:  LastEntries }, meta: { requiresAuth: true } },
  { path: '/edit-entry/:id', name: 'edit-entry', components: { default:  EditEntry }, meta: { requiresAuth: true } },
  { path: '/activities', name: 'activities', components: { default:  Activities }, meta: { requiresAuth: true } },
  { path: '/teams', name: 'teams', components: { default:  Teams }, meta: { requiresAuth: true } },
  { path: '/rows', name: 'rows', components: { default:  Rows }, meta: { requiresAuth: true } },
  { path: '/settings', name: 'settings', components: { default:  Settings }, meta: { requiresAuth: true } },

  { path: '/workday', name: 'workday', components: { default:  Workday, numpad: Numpad }, meta: { requiresAuth: true } },
  { path: '/break', name: 'break', components: { default:  Break, numpad: Numpad }, meta: { requiresAuth: true } },

  { path: '/choose-activity', name: 'activity', components: { default:  ChooseActivity, numpad: Numpad }, meta: { requiresAuth: true } },
  { path: '/choose-team', name: 'team', components: { default:  ChooseTeam, numpad: Numpad }, meta: { requiresAuth: true } },
  { path: '/choose-row', name: 'row', components: { default:  ChooseRow, numpad: Numpad }, meta: { requiresAuth: true } },
  { path: '/select-packaging', name: 'packaging', components: { default:  Packaging, numpad: Numpad }, meta: { requiresAuth: true } },
  { path: '/amount', name: 'amount', components: { default:  Amount, numpad: Numpad }, meta: { requiresAuth: true } },
  { path: '/row-status', name: 'row-status', components: { default:  RowStatus, numpad: Numpad }, meta: { requiresAuth: true } },
  { path: '/row-percentage', name: 'row-percentage', components: { default:  RowPercentage, numpad: Numpad }, meta: { requiresAuth: true } },
]

const router = new VueRouter({ routes });

router.beforeEach((to, from, next) => {
  if(to.meta.requiresAuth) {
    window.localforage.getItem('token')
        .then(function(token) {
          if (token !== null && token !== undefined) next();
          else next({ name: 'login' });
        });
  }

  next();
});

export default router
